import { html, nothing, unsafeCSS } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { EkoElement } from "@/utilities/element";
import { COUNTRIES } from "./countries";
import style from "./flag.css?inline";

@customElement("eko-flag")
class Flag extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  @property({ reflect: true }) country = "";
  @state() flagSrc: string | undefined = undefined;
  @property({ reflect: true }) size: "sm" | "md" | "lg" = "sm";

  private getCountryName(code: string): string {
    const normalized = this.normalizeCountryCode(code);
    return COUNTRIES[normalized as keyof typeof COUNTRIES] ?? "Country";
  }

  private getFlag(code: string) {
    const normalized = this.normalizeCountryCode(code);
    if (!normalized) {
      this.flagSrc = undefined;
      return;
    }

    const url = new URL(`../../assets/flags/${normalized}.svg`, import.meta.url);

    this.flagSrc = url.href;
  }

  private normalizeCountryCode(code: string): string {
    return (code ?? "").trim().toLowerCase();
  }

  firstUpdated() {
    this.getFlag(this.country);
  }

  render() {
    return html`
      ${this.country && this.flagSrc && !this.flagSrc.includes("undefined")
        ? html`<img
            src="${this.flagSrc}"
            class="eko-flag__image"
            part="image"
            alt="${this.getCountryName(this.country)} Flag" />`
        : nothing}
    `;
  }

  updated(changedProperties: Map<string, any>) {
    if (changedProperties.has("country")) {
      this.getFlag(this.country);
    }
  }
}

export default Flag;
